export class DateService {
    formatDateAsString(date: Date): string {
        try {
            let yyyy = date.getFullYear().toString();
            let mm = (date.getMonth() + 1).toString();
            let dd = date.getDate().toString();
            let _mm = (mm[1] ? mm : '0' + mm[0]);
            let _dd = (dd[1] ? dd : '0' + dd[0]);
            return `${yyyy}-${_mm}-${_dd}`;
        } catch (err) {
            return '';
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/date.service.ts